import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vem behöver söka serveringstillstånd?";
const SHORT_ANSWER = "Alla som mot ersättning vill servera spritdrycker, vin, starköl eller andra jästa alkoholdrycker behöver ett serveringstillstånd från kommunen.";

export const Route = createFileRoute("/fraga/vem-behover-serveringstillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vem behöver söka serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det gäller restauranger, barer, hotell, nattklubbar, festivaler, cateringföretag och slutna sällskap där alkohol serveras mot betalning (även dolt, t.ex. via biljettpris). Servering utan tillstånd är straffbart enligt 11 kap. alkohollagen."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Vem behöver tillstånd – fullständig guide" }}
      related={[{"to": "/fraga/vilka-typer-av-serveringstillstand-finns", "label": "Vilka typer av serveringstillstånd finns?"}, {"to": "/fraga/vad-kostar-ansokan", "label": "Vad kostar en ansökan om serveringstillstånd?"}, {"to": "/fraga/vad-ar-serveringstillstand", "label": "Vad är ett serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vem behöver söka serveringstillstånd?" },
      { name: "description", content: "Alla som mot ersättning vill servera spritdrycker, vin, starköl eller andra jästa alkoholdrycker behöver ett serveringstillstånd från kommunen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vem-behover-serveringstillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vem-behover-serveringstillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vem-behover-serveringstillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vem behöver söka serveringstillstånd", url: "https://alkoholprovet.se/fraga/vem-behover-serveringstillstand" },
      ]),
    ],
  }),
});
